import * as React from "react";
import { Classes, Overlay, Button, H5, Intent } from "@blueprintjs/core";
import classNames from "classnames";
import {
    willcallSaveButton, footerOverlayWillcall, labelContainer, flexRow, overlayWillcallContainer, overlayWillcallTitle,
    willcallCancelButton
} from '../../styles';
import { AppToaster } from "../../toastComponent";
import './overlayStyles.css';
import { patchTripWillCall } from "../../services/tripApiService";
import { ERROR_TOAST_ICON } from "../../../utils/Constants";

const OVERLAY_EXAMPLE_CLASS = "docs-overlay-example-transition";
const OVERLAY_TALL_CLASS = "docs-overlay-example-tall";

class OverlayWillcall extends React.PureComponent {

    state = {
        isLoading: false,
        isOpen: true,
    };

    handleConfirm = async () => {
        try {
            this.setState({
                isLoading: true,
            });

            if (this.props.trip.willCallStatus === 'Inactive') {
                patchTripWillCall(this.props.trip.tripNumber, 'Activated')
            }

            AppToaster.show({ message: "Willcall activated successfully.", intent: "success", icon: 'tick', });
        }
        catch (error) {
            console.log(error);
            AppToaster.show({ message: "There was an error. Please try again.", intent: "danger", icon: ERROR_TOAST_ICON, });
        }
        finally {
            this.handleClose();
        }
    }

    render() {
        const classes = classNames(
            Classes.CARD,
            Classes.ELEVATION_4,
            OVERLAY_EXAMPLE_CLASS,
            localStorage.getItem("themeName"),
            { [OVERLAY_TALL_CLASS]: this.state.useTallContent },
        );

        return (
            <Overlay className={Classes.OVERLAY_SCROLL_CONTAINER} transitionName={Classes.OVERLAY} onClose={this.handleClose} {...this.state}>
                <div className={classes} style={overlayWillcallContainer}>
                    <div style={flexRow}>
                        <H5 style={overlayWillcallTitle}>{this.props.message}</H5>
                    </div>
                    <div>
                        <label style={labelContainer}>
                        </label>
                    </div>
                    <br />
                    <div className={Classes.OVERLAY_FOOTER_ACTIONS} style={footerOverlayWillcall}>
                        <Button intent={Intent.SUCCESS} style={willcallSaveButton} onClick={this.handleConfirm} text="Yes" disabled={this.state.isLoading}
                            loading={this.state.isLoading} />
                        <Button intent={Intent.NONE} style={willcallCancelButton} onClick={this.handleClose} text="No" disabled={this.state.isLoading} />
                    </div>
                </div>
            </Overlay>
        );
    }

    handleOpen = () => this.setState({ isOpen: true });

    handleClose = () => {
        this.setState({
            isOpen: false,
            isLoading: false,
        });

        this.props.onModalClosed(this.props.id);
    }
}

export default OverlayWillcall;
